import { render, staticRenderFns } from "./ReadingTraining.vue?vue&type=template&id=94b58868&scoped=true"
import script from "./ReadingTraining.vue?vue&type=script&lang=js"
export * from "./ReadingTraining.vue?vue&type=script&lang=js"
import style0 from "./ReadingTraining.vue?vue&type=style&index=0&id=94b58868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b58868",
  null
  
)

export default component.exports